import React from 'react';
import { getCategoriesForHome } from '../../data/categories';
import './CategoryGrid.css';

// Direct mapping to ensure icons render regardless of CSS conflicts
const GOLF_ICONS = {
  'drivers': '🚀',
  'iron-sets': '⚔️',
  'putters': '🎯',
  'fairway-woods-hybrids': '🌲',
  'wedges': '🏜️',
  'full-sets': '📦',
  'golf-bags': '🎒',
  'golf-carts-trolleys': '🛒',
  'apparel-men': '👕',
  'apparel-women': '👗',
  'golf-shoes': '👟',
  'tech-rangefinders': '⌚',
  'balls-gloves-acc': '⚪',
  'training-aids': '⛳',
  'club-services': '🔧',
  'men-golf': '🏌️‍♂️',
  'women-golf': '🏌️‍♀️',
  'junior-golf': '👦',
};

function CategoryGrid({ onSelectCategory }) {
  const categories = getCategoriesForHome();

  const handleClick = (name, id) => {
    if (onSelectCategory) {
      onSelectCategory(name, id);
    }
  };

  return (
    <div className="categoryGridWrapper">
      <div className="categoryGridStrip">
        <div className="categoryGridScroll">
          {categories.map((cat) => (
            <button
              type="button"
              key={cat.id}
              className="categoryGridItem"
              onClick={() => handleClick(cat.name, cat.id)}
            >
              {/* The icon is now rendered as text inside the div */}
              <div className="categoryGridIcon">
                <span className="categoryEmoji">
                  {GOLF_ICONS[cat.id] || '⛳'}
                </span>
              </div>
              <span className="categoryGridName">{cat.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CategoryGrid;
